import React, { useState } from 'react';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Per-user Stage 0 (Evidence Discovery) toggle. Disabling it sends the next
 *  new assessment straight from Org Profile to the pillar stepper. Existing
 *  assessments are never affected. */
export const Stage0Toggle = ({ userId, enabled }) => {
  const [on, setOn] = useState(enabled !== false);
  const [saving, setSaving] = useState(false);

  const change = async (next) => {
    setSaving(true);
    try {
      await axios.put(
        `${API}/admin/user/${userId}/stage0`,
        { enabled: next },
        { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } },
      );
      setOn(next);
      toast.success(`Stage 0 ${next ? 'enabled' : 'disabled'}`);
    } catch (e) {
      toast.error('Could not update Stage 0');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={on}
        disabled={saving}
        onCheckedChange={change}
        data-testid={`stage0-toggle-${userId}`}
      />
      <span className="text-xs text-slate-500">{on ? 'On' : 'Off'}</span>
    </div>
  );
};

export default Stage0Toggle;
